import { Button } from './Button';
import { Container } from './Container';
import { PlayExampleModal } from './PlayExampleModal';
import { useRandomSampleGame } from './useRandomSampleGame';
import ProceduralBackground from '../games/ProceduralBackground';
import { useSignupModal } from './SignupModalContext';

export function Hero() {
  const { openSignupModal } = useSignupModal();
  const {
    closeSample,
    hasSamples,
    isOpen: exampleOpen,
    openRandomSample,
    playUrl: examplePlayUrl,
    title: exampleTitle,
  } = useRandomSampleGame();

  return (
    <section className="sf-hero" aria-label="Hero">
      <div className="sf-hero-panel">
        <ProceduralBackground rendererKey="skyClouds" isAnimating={false} style={{ opacity: 0.88 }} />
        <div className="sf-hero-skywash" aria-hidden="true" />

        <Container className="sf-hero-container">
          <p className="sf-hero-eyebrow">For repeat campaigns, client activations, and live launches</p>
          <h1>Launch a branded game in minutes</h1>
          <p className="sf-hero-lede">
            Create a branded mini-game with a live leaderboard, share it by QR code or link, and track plays, entries, and CTA clicks from one campaign page.
          </p>

          <div className="sf-hero-actions">
            <Button onClick={openSignupModal} className="h-11 min-w-[176px]">
              Build a game free
            </Button>
            <Button
              variant="outline"
              color="white"
              disabled={!hasSamples}
              onClick={openRandomSample}
              className="sf-sample-game-button h-11 min-w-[190px]"
            >
              Try a sample game
            </Button>
          </div>

          <p className="sf-hero-reassurance">First publish free. £39 each one after.</p>

          <div className="sf-hero-visual" aria-hidden="true">
            <div className="sf-hero-hill sf-hero-hill-back" />
            <div className="sf-hero-hill sf-hero-hill-front" />
          </div>
        </Container>
      </div>
      <PlayExampleModal
        isOpen={exampleOpen}
        onClose={closeSample}
        playUrl={examplePlayUrl}
        title={exampleTitle}
      />
    </section>
  );
}
